import { createStore, applyMiddleware } from "redux";
import rootReducer from "./mainReducer";
import reduxThunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import { persistStore, persistReducer } from "redux-persist";

export const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(reduxThunk))
);

export const persistor = persistStore(store);
